import { render, staticRenderFns } from "./message-list.vue?vue&type=template&id=171d0be0&scoped=true"
import script from "./message-list.vue?vue&type=script&lang=js"
export * from "./message-list.vue?vue&type=script&lang=js"
import style0 from "./message-list.vue?vue&type=style&index=0&id=171d0be0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171d0be0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('171d0be0')) {
      api.createRecord('171d0be0', component.options)
    } else {
      api.reload('171d0be0', component.options)
    }
    module.hot.accept("./message-list.vue?vue&type=template&id=171d0be0&scoped=true", function () {
      api.rerender('171d0be0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/user-messages/message-list.vue"
export default component.exports